<div class="box menu-page">

  <div class="page-header">
    <div class="menu-title-group">
      <div class="menu-app-icon">
        <mat-icon>web_asset</mat-icon>
      </div>
      <div>
        <p class="page-title">{{ applicationName }}</p>
        <p class="page-desc">Manage all aspects of this application — configure channels, control who receives notifications, and set up admin access.</p>
      </div>
    </div>
  </div>

  <div class="menu-grid">

    <div class="menu-card" (click)="viewApplicationdetails()">
      <div class="menu-card__icon menu-card__icon--blue">
        <mat-icon>info</mat-icon>
      </div>
      <div class="menu-card__body">
        <p class="menu-card__title">Application Details</p>
        <p class="menu-card__desc">View API keys, manage channels and notification subscriptions</p>
      </div>
      <mat-icon class="menu-card__arrow">chevron_right</mat-icon>
    </div>

    <div class="menu-card" (click)="viewApplicationUsers()">
      <div class="menu-card__icon menu-card__icon--green">
        <mat-icon>people</mat-icon>
      </div>
      <div class="menu-card__body">
        <p class="menu-card__title">Application Users</p>
        <p class="menu-card__desc">Add or remove users who can receive push notifications from this app</p>
      </div>
      <mat-icon class="menu-card__arrow">chevron_right</mat-icon>
    </div>

    <div class="menu-card" (click)="viewApplicationGroups()">
      <div class="menu-card__icon menu-card__icon--orange">
        <mat-icon>group</mat-icon>
      </div>
      <div class="menu-card__body">
        <p class="menu-card__title">Application Groups</p>
        <p class="menu-card__desc">Organize users into groups and subscribe them to notification channels</p>
      </div>
      <mat-icon class="menu-card__arrow">chevron_right</mat-icon>
    </div>

    <div class="menu-card" (click)="viewApplicationAdmins()">
      <div class="menu-card__icon menu-card__icon--purple">
        <mat-icon>admin_panel_settings</mat-icon>
      </div>
      <div class="menu-card__body">
        <p class="menu-card__title">Application Admins</p>
        <p class="menu-card__desc">Grant admin access to team members who manage this application</p>
      </div>
      <mat-icon class="menu-card__arrow">chevron_right</mat-icon>
    </div>

  </div>
</div>
